// The Win32 Desktop version of outlook provides support for profiles and allows for the same
// account to be stored in multiple profiles. To support this model the sourceId contains a
// profile identifier, applications that don't have profile support use the' main' profile while
// additional profiles are identified by a '|name|' where the || inidicate it is not main.
export const globalProfile = 'main';

// The next part of the sourceId is the type of source, currently the only type of source that is being supported
// is Microsoft 365 hosted accounts. Eventually support will be provided for PST, 3rd party, and other sources.
export const microsoft365SourceType = 'm365';

// Specifies the delimiter used to seperate the parts of the sourceId
const sourcePartDelimiter = ':';

/**
 * Creates a sourceId from the three component parts
 * @param profilePart The profile associated with teh source
 * @param sourceType The type of the source
 * @param sourceIdentifier The stable identifier for the source
 * @param hostingSourceIdentifier Optionally specified the identifier for the account hosting the source
 * @returns a string represeting the source
 */
export function buildSourceId(
    profilePart: string,
    sourceType: string,
    sourceIdentifier: string,
    hostingSourceIdentifier?: string
): string {
    const parts = hostingSourceIdentifier
        ? [profilePart, sourceType, hostingSourceIdentifier, sourceIdentifier]
        : [profilePart, sourceType, sourceIdentifier];

    return parts.join(sourcePartDelimiter);
}
